import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import commonState from './common/state'
import commonMutations from './common/mutations'
import commonGetters from './common/getters'
import commonActions from './common/actions'

import regulatorState from './regulator/state'
import regulatorMutations from './regulator/mutations'
import regulatorActions from './regulator/actions'

import promotionState from './promotion/state'
import promotionMutations from './promotion/mutations'
import promotionActions from './promotion/actions'

import paymentState from './payment/state'
import paymentMutations from './payment/mutations'
import paymentActions from './payment/actions'

import loyaltyState from './loyalty/state'
import loyaltyMutations from './loyalty/mutations'
import loyaltyActions from './loyalty/actions'

import cpsState from './cps/state'
import cpsMutations from './cps/mutations'
import cpsActions from './cps/actions'
import registerModule from './register/registerModule'
import { getRegisterStep } from '@/constants/register/registerStep'
import { getPoaPass } from '@/util/register/getAuditPass'

import propTradingState from './propTrading/state'
import propTradingMutations from './propTrading/mutations'
import propTradingActions from './propTrading/actions'
import propTradingGettters from './propTrading/getters'

import telegramState from './telegram/state'
import telegramMutations from './telegram/mutations'
import telegramActions from './telegram/actions'
import telegramGetters from './telegram/getters'

Vue.use(Vuex)

const common = {
  namespaced: true,
  state: commonState,
  mutations: commonMutations,
  getters: commonGetters,
  actions: commonActions,
}

const regulator = {
  namespaced: true,
  state: regulatorState,
  mutations: regulatorMutations,
  actions: regulatorActions,
}

const promotion = {
  namespaced: true,
  state: promotionState,
  mutations: promotionMutations,
  actions: promotionActions,
}

const payment = {
  namespaced: true,
  state: paymentState,
  mutations: paymentMutations,
  actions: paymentActions,
}

const loyalty = {
  namespaced: true,
  state: loyaltyState,
  mutations: loyaltyMutations,
  actions: loyaltyActions,
}

const cps = {
  namespaced: true,
  state: cpsState,
  mutations: cpsMutations,
  actions: cpsActions,
}

const propTrading = {
  namespaced: true,
  state: propTradingState,
  mutations: propTradingMutations,
  actions: propTradingActions,
  getters: propTradingGettters,
}

const telegram = {
  namespaced: true,
  state: telegramState,
  mutations: telegramMutations,
  actions: telegramActions,
  getters: telegramGetters,
}

export default new Vuex.Store({
  modules: {
    common,
    regulator,
    promotion,
    payment,
    loyalty,
    cps,
    register: registerModule,
    propTrading,
    telegram,
  },
  plugins: [
    createPersistedState({
      paths: ['common', 'regulator', 'promotion', 'cps', 'telegram'],
      getState: (key, storage) => {
        const value = storage.getItem(key)

        try {
          const state = typeof value === 'string' ? JSON.parse(value) : typeof value === 'object' ? value : undefined
          // Init registerModule for registerStep
          if (state.common.registerStep) {
            const currStep = getRegisterStep(
              state.common.registerStep,
              state.common.poaAuditStatus,
              getPoaPass(state.common.poaAuditStatus, state.common.ibtPoaAuditStatus)
            )
            state.register = {}
            state.register.currStep = currStep
            state.register.activeTab = currStep
          }
          return state
        } catch (err) {
          console.log(err)
        }

        return undefined
      },
    }),
  ],
})
